import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px 20px;
  width: 100%;
  min-width: 250px;

  flex: 1;

  // TODO: update this min-width here on the new design - custom breakpoint used on vectorizer
  @media (min-width: 880px) {
    width: 318px;
  }
`;

export const ColorSelection = styled.div<{
  isActive: boolean;
}>`
  background: ${themeStyle.varInkSuperLight};
  border-radius: ${themeStyle.radiusMedium};
  padding: 16px 20px;
  cursor: pointer;

  border: ${({ isActive }) =>
      isActive ? themeStyle.varBlueMedium : 'transparent'}
    solid 2px;
`;

export const ColorIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  filter: ${themeStyle.varShadowSmallHeavy};
`;

// this hack needs to increase image quality for Safari
export const ColorIcon = styled.div<{ src: string }>`
  height: 100%;
  position: relative;
  transform: scale(0.25);
  transform-origin: 0 0;
  &:before {
    content: '';
    position: absolute;
    width: 400%;
    height: 400%;
    background-image: url(${({ src }) => src});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
